import CheckboxRenderer from "components/common/ag-grid/CheckboxRenderer";
import LinkRenderer from "./LinkRenderer";
import React from 'react';
import PropTypes from 'prop-types';

const HierarchyNameRenderer = ({ data }) => {
  const path = data?.hierarchy_path || [data?.name];
  const depth = data?.hierarchy_depth || 0;
  return (
    <div className="tw-flex tw-h-full tw-items-center tw-min-w-0" style={{ paddingLeft: `${depth * 12}px` }} title={path.join(' > ')}>
      {depth > 0 && <span className="tw-mr-1.5 tw-text-slate-300">└</span>}
      <span className="tw-truncate tw-font-medium tw-text-slate-800">{data?.name}</span>
      {path.length > 1 && <span className="tw-ml-2 tw-truncate tw-text-[10px] tw-text-slate-400">{path.slice(0, -1).join(' › ')}</span>}
    </div>
  );
};

HierarchyNameRenderer.propTypes = { data: PropTypes.object };

export const columnDefs = [
  { 
    headerName: 'ID#',
    field: 'id',
    minWidth: 110,
    cellRenderer: LinkRenderer
  },
  { 
    headerName: 'Name',
    field: 'name',
    minWidth: 180,
    cellRenderer: HierarchyNameRenderer
  },
  { 
    headerName: 'Description',
    field: 'description',
    minWidth: 150
  },
  { 
    headerName: 'Region',
    field: 'region',
    minWidth: 120
  },
  { 
    headerName: 'Parent',
    field: 'parent_id',
    minWidth: 120
  },
  { 
    headerName: 'Sales admin',
    field: 'sales_admin',
    minWidth: 120
  },
  { 
    headerName: 'Sales leader',
    field: 'sales_leader',
    minWidth: 120
  },
  { 
    headerName: 'Chief Ref/GM',
    field: 'sales_manager',
    minWidth: 120
  },
  { 
    headerName: 'Active',
    field: 'active',
    minWidth: 100,
    cellRenderer: CheckboxRenderer
  },
  { 
    headerName: 'Type of sales',
    field: 'type_of_sales',
    minWidth: 120
  },
  { 
    headerName: 'Created date',
    field: 'created_at',
    minWidth: 170
  },
]
